module.exports = "https://www.gc-pro.gnp.com.mx/6a8fa828d02a384fe112c2e6007eba71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/vida-03.svg
// module id = 8173
// module chunks = 0